function isObject(obj) {
    if (obj === null) return false;

    return obj === Object(obj) && !Array.isArray(obj);
}

/**
 * @description Используется для инициализации модулей, не включенных в базовый бандл app.js
 * @param components {object}
 */
export default function initComponents(components) {
    if (isObject(components)) {
        document.dispatchEvent(
            new CustomEvent(
                'addNewComponent',
                {
                    detail:  Object.entries(components).map(
                        ([componentName, component] = []) => ({componentName, component})
                    )
                }
            )
        );
    } else {
        console.warn(`Components should be typeof Object`);
    }
}
